/**
 * Rounds a number, null-safe.
 * @param {Number} value value to round.
 * @param {int} [digits] Optional. The number of digits to appear after the decimal point; this may be a
 * value between 0 and 20, inclusive, and implementations may optionally support a larger range of values. If this argument is omitted, it is treated as 0.
 * @returns {string|*} Rounded number, if it's defined; else, return empty string
 */

function round(value, digits = 2) {
    if (value || value === 0) {
        return value.toFixed(digits);
    }
    return '';
}
/**
 * Adds 0 padding to single digits.
 * @param {*} value
 * @returns {string}
 */
function add0Padding(value) {
    return `0${value}`.slice(-2);
}

// vehicle value restrict keys
function allowOnlyNumbers($event) {
    // if the letter is not a digit or a dot (46) then display error and don't type anything
    // The event.which property normalizes event.keyCode and event.charCode
    const charCode = ($event.which) ? $event.which : $event.keyCode;
    if (charCode !== 8 && charCode !== 0 && (charCode < 48 || charCode > 57)) {
        $event.preventDefault();
    }
}

// prevents entering number in input
function restrictNumbers($event) {
    const keyCode = ($event.keyCode ? $event.keyCode : $event.which);
    if (keyCode > 47 && keyCode < 58) {
        $event.preventDefault();
    }
}
// allow only numbers and no leading zeros
function numbersOnlyWithNoLeadingZero(value) {
    const re = /^[1-9]\d*$/;
    return (value === '' || re.test(value));
}

// allow only numbers
function numbersOnly(value) {
    const re = /^[0-9]*$/;
    return (value === '' || re.test(value));
}

/**
 * If value is defined:
 * Rounds the value up to the nearest limit defined in roundingLimits. If a nearest limit
 * is not found, e.g. roundingLimits is empty or undefined, rounds up to the closest thousand.
 * @param {Number} value
 * @param {Array} roundingLimits, sorted array of rounding intervals. Can be empty or undefined.
 * @returns {Number} a new value, rounded up, if value is defined. Returns value otherwise.
 */
function roundUp(value, roundingLimits = []) {
    if (!value && value !== 0) {
        return value;
    }

    if (value === 0) {
        // eslint-disable-next-line no-param-reassign
        value = 1;
    }

    const limit = roundingLimits.find((limitAmount) => {
        return value <= limitAmount;
    });
    return limit || Math.ceil(value / 1000) * 1000;
}

/**
 * @param {Number[]} values, an array of values to sum
 * @returns {Number} the sum of the values. falsey values are converted to zeros
 */
function sum(values) {
    return values.reduce((currentSum, value) => (value ? currentSum + value : currentSum), 0);
}

function getPriceInteger(value) {
    return Math.floor(value).toString();
}

function getPriceFraction(value) {
    let val = value;
    if (value.toFixed) {
        val = value.toFixed(2);
    }
    return val.slice(val.indexOf('.'));
}

function getFullPriceWithFraction(value) {
    return `${getPriceInteger(value)}${getPriceFraction(value)}`;
}

function roundAmount(value, fractionOnlyWhenNeeded) {
    const hasFraction = value - Math.floor(value) > 0;
    if (!hasFraction && fractionOnlyWhenNeeded) {
        return value;
    }
    return parseFloat(value).toFixed(2);
}

function getCurrencyValue(intl, value, noFractionWhenZero, positiveAmount) {
    const fractionValue = noFractionWhenZero && value.amount === 0 ? 0 : 2;
    return intl.formatNumber(
        positiveAmount ? Math.abs(value.amount) : value.amount,
        {
            style: 'currency',
            currency: value.currency,
            currencyDisplay: 'symbol',
            maximumFractionDigits: fractionValue
        }
    );
}

function addThousandsCommaSeparator(value) {
    const string = `${value}`;
    return string.length > 3 ? `${string.slice(0, -3)},${string.slice(-3)}` : string;
}

function addThousandsCommaSeparatorForPrice(value) {
    const stringVal = `${value}`;
    const parts = stringVal.split('.');
    let result = addThousandsCommaSeparator(parts[0]);
    if (parts[1] !== undefined) {
        result = parts[1].length === 1 ? `${result}.${parts[1]}0` : `${result}.${parts[1]}`;
    }
    return result;
}

export default {
    round,
    roundAmount,
    add0Padding,
    roundUp,
    restrictNumbers,
    allowOnlyNumbers,
    sum,
    numbersOnlyWithNoLeadingZero,
    numbersOnly,
    getPriceInteger,
    getPriceFraction,
    getFullPriceWithFraction,
    getCurrencyValue,
    addThousandsCommaSeparator,
    addThousandsCommaSeparatorForPrice
};
